export default "__VITE_ASSET__1956a734__"